import React from "react";
import { CardElement } from "@stripe/react-stripe-js";
import { StripeCardElementOptions } from "@stripe/stripe-js";

import { cssVariables, stylex } from "../components";

interface PaymentInputProps {
  onChange?: (complete: boolean, error?: string) => void;
  disabled?: boolean;
  invalid?: boolean;
  disableLink?: boolean;
}

export function PaymentInput(props: PaymentInputProps) {
  const { onChange = () => {}, disabled, invalid, disableLink } = props;
  const [isFocused, setIsFocused] = React.useState(false);

  const handleChange = React.useCallback(
    (event: { complete: boolean; error?: { message: string } }) => {
      onChange(event.complete, event.error?.message);
    },
    [onChange]
  );

  const CARD_ELEMENT_OPTIONS: StripeCardElementOptions = {
    disabled: !!disabled,
    disableLink,
    style: {
      base: {
        color: "#32325d",
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  return (
    <div
      style={{
        ...styles(
          "base",
          disabled && "disabled",
          invalid && "invalid",
          isFocused && "focus"
        ),
      }}
    >
      <CardElement
        options={CARD_ELEMENT_OPTIONS}
        onChange={handleChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
    </div>
  );
}

const styles = stylex.create({
  base: {
    padding: 8,
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: cssVariables.radius,
    borderColor: cssVariables.borderColorDark,
  },
  disabled: {
    boxShadow: "inset 0 0 490px rgba(0, 0, 0, 0.03)",
  },
  focus: {
    borderColor: cssVariables.borderColorFocus,
  },
  invalid: {
    borderColor: cssVariables.borderColorDanger,
  },
});
